<template>
  <div class="Home" ref='Home'>
    <!-- 首页banner -->
    <HomeBanner></HomeBanner>
    <div :style="backgroundImageStyle" class="home-bg">
      <ArtRecommendation></ArtRecommendation>
      <AboutHippoArt></AboutHippoArt>
      <ArtistRecommendation></ArtistRecommendation>
      <ConsultRecommend></ConsultRecommend>
    </div>
  </div>
</template>

<script>
// import Swiper from "swiper"
// import "swiper/swiper-bundle.css";
import HomeBanner from "@/components/Home/HomeBanner"; // banner
import ArtRecommendation from "@/components/Home/ArtRecommendation"; // 艺术品推荐
import AboutHippoArt from "@/components/Home/AboutHippoArt"; // 关于河马艺术
import ArtistRecommendation from "@/components/Home/ArtistRecommendation"; // 政策申报
import ConsultRecommend from "@/components/Home/ConsultRecommend"; //咨询推荐
import { getStore } from "@/utils/auth";
import Utils from "@/utils/util";
export default {
  name: "Home",
  components: {
    HomeBanner,
    ArtRecommendation,
    AboutHippoArt,
    ArtistRecommendation,
    ConsultRecommend,
  },
  data() {
    return {
      token: getStore("token"),
      windowWidth: window.innerWidth,
      navStatus: 0,
      typeData: [],
      companyNav: [],
    };
  },
  watch: {
    $route(newValue) {
      if (newValue.name === 'Home') {
        this.$nextTick(() => {
          this.getScroll('Home','Home')
          console.log(document.documentElement.scrollHeight);
          console.log(window.pageYOffset);
        })
      }
    },
  },
  computed: {
    backgroundImageStyle() {
      if (this.windowWidth >= 1024) {
        return {
          backgroundImage: `url(${require("@/assets/home/Banner/home_bg.png")})`,
        };
      } else {
        return {
          backgroundImage: `url(${require("@/assets/home/Banner/mobile.png")})`,
        };
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  // beforeRouteLeave(to, from, next) {
  //   console.log(to,from,next);
  //   if (to.name !== 'Home') {
  //     console.log('记录位置!!!!!');
  //     this.scrollRecord('Home','Home')
  //   }
  //   next()
  // },
  created() {
    setTimeout(() => {
      document.documentElement.scrollTop = 0;
    }, 100);
    this.token = getStore("token");
    this.$store.commit("changeShowBreadcrumbState", false);
    // 循环数据   每三个放到新数组
    let SplitArray = function(N, Q) {
      let R = [],
        F;
      for (F = 0; F < Q.length; ) R.push(Q.slice(F, (F += N)));
      return R;
    };
    let arr = this.typeData;
    this.typeData = SplitArray(3, arr);

  },
  mounted() {
    console.log('home mounted!!!!!!!!!!');
    if (!this.$common.isEmpty(this.$route.params.type)) {
      Utils.$emit("toLogin", 2);
    }
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    // 循环数组Q  每N个放到新数组
    SplitArray(N, Q) {
      let R = [],
        F;
      for (F = 0; F < Q.length; ) R.push(Q.slice(F, (F += N)));
      return R;
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/static/styles/variables.less";
@import "~@/static/styles/index.less";
.Home {
  width: 100vw;
  // min-width: @commentWidth;;
  font-family: PingFang-SC;
  background-color: #ffffff;
  .row_box {
    margin: 0 auto;
    width: 100vw;
    height: 583px;
    display: flex;
    justify-content: center;
    background: linear-gradient(137deg, #f5fafc 0%, #e6ebf2 100%);
    .tech_list {
      width: auto;
      display: flex;
      // flex:14;
      justify-content: flex-end;
      max-width: 1130px;
      height: 100%;
      .bg_img {
        position: absolute;
        width: 1130px;
        height: 583px;
        z-index: 0;
      }
    }
    .doctor_list {
      // width: 100%;
      max-width: 790px;
      // flex:10;
      display: flex;
      // background: linear-gradient(137deg, #F5FAFC 0%, #E6EBF2 100%);
      .doctor_content {
        width: 440px;

        padding-top: 28px;
      }
    }
  }
  .aboutThis {
    width: 100vw;
    // min-width: @commentWidth;;
    background-image: url("http://scitrm-verify.oss-cn-beijing.aliyuncs.com/2021/04/20/b3ffdc80-c019-4c0f-a6f1-adf27ed6e849.png");
    background-size: 100% 100%;
    margin-bottom: 30px;
    .aboutBox {
      width: @defaultWidth;
      margin: 0 auto;
      padding-top: 50px;
      .nav_box {
        color: #6c6c6c;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-flow: row wrap;
        .nav_left {
          flex: 1;
          display: flex;
          font-size: 16px;
          font-weight: bold;
          .navItem {
            padding: 13px 8px;
            // margin-right: 3vw;
            margin-right: 20px;
            cursor: pointer;
          }
          .navActive {
            padding: 13px 8px;
            // margin-right: 2vw;
            margin-right: 20px;
            cursor: pointer;
            color: #19caad;
            border-bottom: 2px solid #19caad;
          }
        }
        .nav_right {
          // width: 30vw;
          flex: 1;
          background: rgba(255, 255, 255, 0.86);
          border-radius: 32px;
          border: 1px solid #94dbcf;
          // text-align: center;
          font-size: 16px;
          font-weight: bold;
          color: #19caad;
          span {
            cursor: pointer;
          }
        }
      }
      .content {
        margin-top: 40px;
        .aboutTitle {
          font-size: 34px;
          font-weight: bold;
          color: #343434;
          line-height: 48px;
        }
        .aboutContent {
          width: 100%;
          font-size: 18px;
          font-weight: 500;
          color: #343434d2;
          line-height: 36px;
          margin-top: 15px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          word-break: break-all;
        }
        .chackMore {
          font-size: 16px;
          font-family: PingFang-SC-Regular, PingFang-SC;
          font-weight: 400;
          color: #19caad;
          float: right;
          line-height: 38px;
          cursor: pointer;
        }
        .swiperContent {
          width: 100%;
          margin: 0 auto;
          background: transparent;
          margin-top: 50px;
          .swiper_box {
            width: 100%;
            height: 473px;
            margin: 0 auto;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }

  .resultWrap {
    width: @defaultWidth;
    max-width: @maxWidth;
    margin: 0 auto;
    .resultTop {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-flow: row wrap;
      font-size: 34px;
      font-weight: bold;
      color: #3b3b3b;
      line-height: 48px;
      margin-bottom: 10px;
      img {
        cursor: pointer;
      }
    }
    .resultBottom {
      border-top: 1px dashed #97979782;
      border-bottom: 1px dashed #97979782;
      margin-bottom: 30px;
      .swiperContent {
        width: 100%;
        margin: 0 auto;
        background: transparent;
        .swiper_box {
          width: 100%;
          // height: 340px;
          height: 35vh;
          margin: 0 auto;
          .resultBox {
            display: flex;
            height: 100%;
            .resultItem {
              flex: 1;
              width: 50%;
              display: flex;
              margin-right: 25px;
              padding: 35px 25px;
              cursor: pointer;
              .itemLeft {
                flex: 3;
                .itemTitle {
                  font-size: 22px;
                  font-weight: bold;
                  color: #3b3b3b;
                  line-height: 30px;
                  margin: 30px 0 10px 0;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                  word-break: break-all;
                }
                .itemEnglish {
                  font-size: 14px;
                  font-family: PingFang-SC-Regular, PingFang-SC;
                  font-weight: 400;
                  color: #797979;
                  line-height: 26px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                  word-break: break-all;
                }
                .itemContent {
                  // width: 30%;
                  height: 68px;
                  font-size: 16px;
                  font-weight: 500;
                  color: #343434d2;
                  line-height: 22px;
                  margin-top: 60px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 3;
                  word-break: break-all;
                }
                .itemMore {
                  margin-top: 25px;
                  cursor: pointer;
                }
              }
              .itemRight {
                flex: 2;
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;
                margin-left: 20px;
                .rightImg {
                  // margin-top: 5%;
                  width: 100%;
                  height: 100%;
                  img {
                    // width: 100%;
                    // height: 100%;
                    width: 15vw;
                    height: 14vw;
                  }
                }
              }
            }
            .resultItem:last-child {
              margin: 0;
              background: #f7f7f7;
            }
            .resultItem:first-child {
              padding-left: 0;
            }
          }
        }
      }
    }
  }
  .partnerWrap {
    width: 100%;
    background-image: url("http://scitrm-verify.oss-cn-beijing.aliyuncs.com/2021/04/21/299de02b-4f05-4849-bf19-78b11bd8aac2.png");
    background-size: 100% 100%;
    margin-bottom: 30px;
    .partnerBox {
      padding: 30px 0 0 0;
      margin: 0 auto;
      .partner_title {
        width: 78%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-flow: row wrap;
        font-size: 34px;
        font-weight: bold;
        color: #ffffff;
        line-height: 48px;
        border-bottom: 1px dashed #ffffff;
        padding: 0 10px 20px 10px;
        .checkAll {
          // margin-right: 7vw;
          cursor: pointer;
        }
      }
      .swiperContent {
        width: @defaultWidth;
        margin: 0 auto;
        background: transparent;
        .swiper_box {
          width: 100%;
          height: 180px;
          margin: 0 auto;
          .linkBox {
            display: flex;
            align-items: center;
            padding: 0 40px;
            margin-top: 40px;
          }
          .linkItem {
            // flex: 1;
            width: 20%;
            font-size: 16px;
            font-family: PingFang-SC;
            font-weight: bold;
            color: #ffffff;
            line-height: 48px;
            padding: 25px 0;
            // padding: 10px 50px;
            cursor: pointer;
            img {
              // width: 180px;
              width: 100%;
            }
          }
        }
      }
    }
  }
  .serverWrap {
    width: @defaultWidth;
    max-width: @maxWidth;
    margin: 0 auto;
    margin-bottom: 30px;
    .serverTop {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-flow: row wrap;
      font-size: 34px;
      font-weight: bold;
      color: #3b3b3b;
      line-height: 48px;
      margin-bottom: 10px;
      padding-bottom: 10px;
      border-bottom: 1px dashed #97979782;
      img {
        cursor: pointer;
      }
    }
    .serverBottom {
      display: flex;
      justify-content: space-between;
      padding: 30px 0;
      .server_left {
        flex: 1;
        .leftBox {
          width: 100%;
          display: flex;
          align-items: center;
          margin-top: 40px;
          cursor: pointer;
          .leftIcon {
            img {
              width: 63px;
              height: 63px;
            }
          }
          .leftInfo {
            margin-left: 20px;
            .leftTitle {
              width: 100%;
              font-size: 22px;
              font-weight: bold;
              color: #3b3b3b;
              line-height: 30px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              word-break: break-all;
            }
            .descBox {
              font-size: 22px;
              display: flex;
              align-items: center;
              margin-top: 10px;
              .descItem {
                // min-width: 70px;
                width: 15vw;
                margin-right: 10px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                word-break: break-all;
              }
              img {
                cursor: pointer;
              }
            }
          }
        }
        .leftBox:first-child {
          margin-top: 0;
        }
      }
      .server_right {
        flex: 2;
        display: flex;
        // flex-direction: row;
        // justify-content: space-between;
        .right_item {
          width: 33%;
          margin-right: 20px;
          cursor: pointer;
          .rightImg {
            width: 100%;
            img {
              width: 100%;
              height: 100%;
              // width: 200px;
              // height: 200px;
              width: 15vw;
              height: 15vw;
            }
          }
          .rightTitle {
            font-size: 27px;
            font-weight: bold;
            color: #3b3b3b;
            line-height: 38px;
            margin-top: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            word-break: break-all;
          }
          .priceBox {
            display: flex;
            align-items: center;
            margin-top: 15px;
            .priceNum {
              font-size: 29px;
              font-family: DIN-Bold, DIN;
              font-weight: bold;
              color: #cc2323;
              line-height: 35px;
            }
          }
        }
        .right_item:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .finance_box {
    width: @defaultWidth;
    min-width: @maxWidth;
    margin: 0 auto;
    margin-bottom: 80px;
  }
  .translation_box {
    display: flex;
    width: @defaultWidth;
    min-width: @maxWidth;
    margin: 0 auto;
    margin-bottom: 30px;
    .others {
      margin-top: 49px;
      .other_item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 240px;
        height: 90px;
        border-radius: 10px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 25px;
        img {
          margin-right: 20px;
          width: 43px;
          height: 43px;
        }
        &.item_files {
          background: rgba(232, 242, 253);
          color: #6ca0ea;
          margin-bottom: 14px;
        }
        &.item_download {
          background: rgba(234, 250, 253);
          color: #5dd7f1;
        }
      }
    }
  }
  .develop_box {
    display: flex;
    width: @defaultWidth;
    min-width: @maxWidth;
    margin: 0 auto;
  }
  .tech-source_box {
    width: 100%;
    // height: 384px;
    // background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
  }
  .tech-area_box {
    display: flex;
    width: @defaultWidth;
    min-width: @maxWidth;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 63px;
  }
  .twoBox {
    width: @defaultWidth;
    max-width: @maxWidth;
    height: 160px;
    margin: 0 auto;
    display: flex;
    .leftBox {
      flex: 1;
      margin-right: 10px;
      background-image: url("http://scitrm-verify.oss-cn-beijing.aliyuncs.com/2021/06/02/7e7b98d5-817b-4f94-a913-8afeb3504541.png");
      background-size: 100% 100%;
      position: relative;
      .leftItem {
        width: 128px;
        position: absolute;
        top: 38px;
        left: 50px;
        text-align: left;
        .title {
          font-size: 20px;
          font-weight: bold;
          color: #282828;
          line-height: 28px;
        }
        .btn {
          height: 36px;
          background: #46b942;
          font-size: 14px;
          border-radius: 5px;
          font-weight: bold;
          color: #ffffff;
          line-height: 36px;
          text-align: center;
          margin-top: 17px;
          cursor: pointer;
        }
      }
    }
    .rightBox {
      flex: 1;
      margin-left: 10px;
      background-image: url("http://scitrm-verify.oss-cn-beijing.aliyuncs.com/2021/06/02/5b811dcb-f5ea-4b26-af19-bfdb6115fde5.png");
      background-size: 100% 100%;
      position: relative;
      .rightItem {
        width: 128px;
        position: absolute;
        top: 38px;
        right: 50px;
        text-align: right;
        .title {
          font-size: 20px;
          font-weight: bold;
          color: #282828;
          line-height: 28px;
        }
        .btn {
          height: 36px;
          background: #46b942;
          font-size: 14px;
          border-radius: 5px;
          font-weight: bold;
          color: #ffffff;
          line-height: 36px;
          text-align: center;
          margin-top: 17px;
          cursor: pointer;
        }
      }
    }
  }
  .resourceWrap {
    width: @defaultWidth;
    max-width: @maxWidth;
    margin: 0 auto;
    margin-bottom: 30px;
    .resourceTop {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-flow: row wrap;
      font-size: 34px;
      font-weight: bold;
      color: #3b3b3b;
      line-height: 48px;
      margin-bottom: 10px;
      padding-bottom: 10px;
      // border-bottom: 1px dashed #97979782;
      img {
        cursor: pointer;
      }
    }
    .resourceBottom {
      width: 100%;
      .resourceBox {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .resourceItem {
          flex: 1;
          text-align: center;
          .itemTop {
            height: 104px;
            padding: 40px 0;
            background: #19caad;
            cursor: pointer;
            border-right: 1px solid #ffffff;
            .titleBox {
              display: flex;
              align-items: center;
              justify-content: center;
              .titleItem {
                div {
                  font-size: 20px;
                  font-weight: bold;
                  color: #ffffff;
                  line-height: 28px;
                  margin-top: 10px;
                }
              }
              .itemIcon {
                margin-left: 50px;
              }
            }
          }
          .itemBottom {
            background: #f7f7f7;
            padding: 30px 0;
            .itemList {
              margin-top: 30px;
              .listItem {
                font-size: 18px;
                font-weight: 500;
                color: #3b3b3b;
                line-height: 25px;
                cursor: pointer;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                word-break: break-all;
              }
            }
            .itemList:first-child {
              margin-top: 0px;
            }
          }
        }
      }
      .resourceItem:last-child {
        border: none;
      }
    }
  }
  .expertsWrap {
    width: @defaultWidth;
    max-width: @maxWidth;
    margin: 0 auto;
    margin-bottom: 30px;
    .expertsTop {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-flow: row wrap;
      font-size: 34px;
      font-weight: bold;
      color: #3b3b3b;
      line-height: 48px;
      margin-bottom: 10px;
      padding-bottom: 10px;
      border-bottom: 1px dashed #97979782;
      img {
        cursor: pointer;
      }
    }
    .expertsBottom {
      width: 100%;
      .swiperContent {
        width: 100%;
        margin: 0 auto;
        background: transparent;
        .swiper_box {
          width: 100%;
          height: 240px;
          margin: 0 auto;
          .expertsBox {
            display: flex;
            margin-top: 20px;
            .expertsItem {
              // flex: 1;
              width: 33%;
              margin-left: 25px;
              cursor: pointer;
              .expertsCard {
                padding: 10px;
                .infoBox {
                  display: flex;
                  .expertsImg {
                    // flex: 1;
                    img {
                      width: 130px;
                      height: 180px;
                    }
                  }
                  .expertsInfo {
                    // flex: 2;
                    margin-left: 20px;
                    .expertsName {
                      font-size: 22px;
                      font-weight: bold;
                      color: #3b3b3b;
                      line-height: 30px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      display: -webkit-box;
                      -webkit-box-orient: vertical;
                      -webkit-line-clamp: 1;
                      word-break: break-all;
                    }
                    .infoBottom {
                      font-size: 16px;
                      font-weight: 500;
                      color: #797979;
                      line-height: 35px;
                      margin-top: 50px;
                      div {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        word-break: break-all;
                      }
                    }
                  }
                }
              }
            }
            .expertsItem:first-child {
              margin: 0;
            }
          }
        }
      }
    }
  }
  .medicalWrap {
    width: @defaultWidth;
    max-width: @maxWidth;
    margin: 0 auto;
    margin-bottom: 30px;
    padding-bottom: 30px;
    .medicalTop {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-flow: row wrap;
      margin-bottom: 10px;
      padding-bottom: 10px;
      border-bottom: 1px dashed #97979782;
      .medicalTitle {
        display: flex;
        align-items: center;
        .medicalText {
          font-size: 34px;
          font-weight: bold;
          color: #3b3b3b;
          line-height: 48px;
        }
        .medicalNav {
          display: flex;
          margin-left: 5vw;
          .navList {
            margin-right: 2vw;
            font-size: 22px;
            font-weight: bold;
            color: #3b3b3b;
            line-height: 30px;
            cursor: pointer;
            .navActive {
              cursor: pointer;
              color: #19caad;
              padding: 0 8px 10px 8px;
              border-bottom: 2px solid #19caad;
            }
          }
        }
      }
      img {
        cursor: pointer;
      }
    }
    .medicalBottom {
      .medicalItem {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        // flex-flow: row wrap;
        .medicalName {
          width: 25%;
          margin-top: 40px;
          font-size: 18px;
          font-weight: 500;
          color: #343434d2;
          line-height: 25px;
          cursor: pointer;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          word-break: break-all;
          li::marker {
            color: #19caad;
            font-size: 18px;
          }
        }
      }
    }
  }
  .companyWrap {
    width: 100%;
    background: #f7f7f7;
    padding: 30px 0;
    .companyBox {
      width: @defaultWidth;
      max-width: @maxWidth;
      margin: 0 auto;
      margin-bottom: 30px;
      .companyTop {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-flow: row wrap;
        margin-bottom: 10px;
        padding-bottom: 10px;
        border-bottom: 1px dashed #97979782;
        .companyTitle {
          display: flex;
          align-items: center;
          .companyText {
            font-size: 34px;
            font-weight: bold;
            color: #3b3b3b;
            line-height: 48px;
          }
          .companyNav {
            display: flex;
            margin-left: 5vw;
            .navList {
              margin-right: 2vw;
              font-size: 22px;
              font-weight: bold;
              color: #3b3b3b;
              line-height: 30px;
              cursor: pointer;
              .navActive {
                cursor: pointer;
                color: #19caad;
                padding: 0 8px 10px 8px;
                border-bottom: 2px solid #19caad;
              }
            }
          }
        }
        img {
          cursor: pointer;
        }
      }
      .companyBottom {
        .companyItem {
          display: flex;
          align-items: center;
          // justify-content: space-between;
          // flex-flow: row wrap;
          .companyName {
            width: 25%;
            margin-top: 40px;
            font-size: 18px;
            font-weight: 500;
            color: #343434d2;
            line-height: 25px;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            word-break: break-all;
            li::marker {
              color: #19caad;
              font-size: 18px;
            }
          }
        }
      }
    }
  }
  .footer {
    width: 100%;
    // min-width: @commentWidth;;
    background-color: #46b942;
    background-image: url("http://scitrm-verify.oss-cn-beijing.aliyuncs.com/2021/04/20/3c92f609-2c8c-4ed5-8267-c58429205ead.png");
    background-size: 100% 100%;
    font-family: PingFang-SC;
    .footer_content {
      padding: 30px 0 0 0;
      margin: 0 auto;
      .footer_title {
        width: @defaultWidth;
        max-width: @maxWidth;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-flow: row wrap;
        font-family: PingFang-SC;
        font-weight: bold;
        color: #ffffff;
        border-bottom: 1px dashed #ffffff;
        .checkAll {
          cursor: pointer;
          img {
            margin-right: 0;
          }
        }
      }
      .swiperContent {
        width: @defaultWidth;
        margin: 0 auto;
        background: transparent;
        .swiper_box {
          width: 100%;
          height: 200px;
          margin: 0 auto;
          .linkBox {
            display: flex;
            align-items: center;
            padding: 40px 60px;
            // margin-top: 40px;
          }
          .linkItem {
            // flex: 1;
            position: relative;
            width: 30%;
            min-width: 180px;
            height: 105px;
            border-right: 1px dashed #ffffff;
            padding: 10px 40px;
            .itemName {
              // width: 250px;
              font-size: 16px;
              font-family: PingFang-SC;
              font-weight: bold;
              color: #ffffff;
              line-height: 16px;
              margin-top: -10px;
              .text_overflow_hidden_lines(1);
            }
            .itemTitle {
              // width: 90%;
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: 500;
              line-height: 18px;
              color: #ffffff;
              margin-top: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              word-break: break-all;
            }
            .goNext {
              width: 126px;
              height: 31px;
              position: absolute;
              bottom: 0;
              border: 1px solid #ffffff;
              color: #ffffff;
              line-height: 31px;
              text-align: center;
              margin-top: 30px;
              // float: right;
              cursor: pointer;
            }
          }
          .linkItem:last-child {
            border: none;
          }
        }
      }
    }
  }
  .home-bg {
    background-size: 100% 100%;
  }
}
</style>
<style lang="less">
.aboutBox {
  .el-input__inner {
    border: none;
    font-size: 18px;
    font-weight: 500;
    color: #737373;
    line-height: 28px;
  }
  .el-input-group__prepend div.el-select .el-input__inner {
    color: #19caad;
    font-size: 18px;
    font-weight: bold;
    line-height: 25px;
  }
  .el-icon-caret-right:before {
    font-size: 16px;
  }
  .el-input-group__append,
  .el-input-group__prepend {
    border: none;
    background-color: #fff;
    border-right: 1px dashed #ced3d7;
    // width: 35%;
    width: 135px;
    padding-left: 0;
    padding-right: 0;
    border-radius: 32px;
    // float: left;
  }
  .el-select .el-input .el-select__caret {
    color: #19caad;
  }
  .el-input-group__append .el-button,
  .el-input-group__append .el-select,
  .el-input-group__prepend .el-button,
  .el-input-group__prepend .el-select {
    margin: 0;
  }
  .el-button--success {
    background-color: #46b942;
    border: 1px solid #46b942;
    float: right;
  }
}
.expertsBox {
  .el-card__body {
    padding: 0;
  }
}
</style>
